class LobCodeService {
  constructor () {
    this.hazardCodes = [3, 16, 19, 81];
    this.vehicleCodes = [9, 10, 14, 28, 69, 77, 83];
    this.boatCodes = [14, 83];
    this.scheduleCodes = [45, 46, 4, 71, 21, 20, 60];
    this.homeCodes = [12, 29, 35, 39, 40, 44, 46, 54, 67, 68, 71, 80];
    this.lobCodes = {
      0: 'Unknown',
      1: 'ACCT',
      2: 'AGENT',
      3: 'AGLIA',
      4: 'AGPP',
      5: 'AGPR',
      6: 'ANUTY',
      7: 'APKGE',
      8: 'ARCH',
      9: 'AUTOB',
      10: 'AUTOP',
      11: 'BANDM',
      12: 'BLDRK',
      13: 'BMSBP',
      14: 'BOAT',
      15: 'BOP',
      16: 'BOPGL',
      17: 'BOPPR',
      18: 'CFIRE',
      19: 'CGL',
      20: 'COMAR',
      21: 'CONTR',
      22: 'CPKGE',
      23: 'CPL',
      24: 'CRIM',
      25: 'CROP',
      26: 'CUMBR',
      27: 'CYBER',
      28: 'CYCLE',
      29: 'DFIRE',
      30: 'DO',
      31: 'EDP',
      32: 'ELIAB',
      33: 'EO',
      34: 'EPLI',
      35: 'EQ',
      36: 'EQLIA',
      37: 'FIDUC',
      38: 'FINAR',
      39: 'FLOOD',
      40: 'FRBD',
      41: 'GARAG',
      42: 'GLASS',
      43: 'HEALTH',
      44: 'HOME',
      45: 'INMRC',
      46: 'INMRP',
      47: 'INTER',
      48: 'KIDRA',
      49: 'LAW',
      50: 'LIFE',
      51: 'LL',
      52: 'LMORT',
      53: 'MEDIA',
      54: 'MHOME',
      55: 'MMAL',
      56: 'MOPRO',
      57: 'MPL',
      58: 'MTRCR',
      59: 'MTRTK',
      60: 'OCMRC',
      61: 'OPCAR',
      62: 'OTHER',
      63: 'PHYS',
      64: 'PL',
      65: 'PLMSC',
      66: 'PPKGE',
      67: 'PROP',
      68: 'PUMBR',
      69: 'RECV',
      70: 'RRPRL',
      71: 'SCHPR',
      72: 'SFRNC',
      73: 'SIGNS',
      74: 'SMP',
      75: 'SURE',
      76: 'TRANS',
      77: 'TRKRS',
      78: 'ULIFE',
      79: 'VALP',
      80: 'WIND',
      81: 'WORK',
      82: 'WORKV',
      83: 'YACHT'
    };
  }

  isHomePolicy (code) {
    return this.homeCodes.includes(code);
  }

  containsHazards (code) {
    return this.hazardCodes.includes(code);
  }

  containsWorkHazards (code) {
    return code === 81;
  }

  containsSchedules (code) {
    return this.scheduleCodes.includes(code);
  }

  containsVehicles (code) {
    return this.vehicleCodes.includes(code);
  }

  containsBoats (code) {
    return this.boatCodes.includes(code);
  }
}

var x = new LobCodeService();
export default x;
